import React, { Component } from 'react';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import selectors from '../../selectors';
import CartActions from '../../actions/cart';
import PropTypes from 'prop-types';
import MapPropTypes from '../MapPropTypes';
import CartItem from './CartItem';
import strings from '../../strings';
import './Cart.scss';

class Cart extends Component {
    static propTypes = {
        offer: MapPropTypes.OfferProps,
        isPricingContinuous: PropTypes.bool.isRequired,
        hasOnlyWeeklyPricing: PropTypes.bool.isRequired,
        serversBySite: PropTypes.arrayOf(MapPropTypes.SiteProps),
        cart: MapPropTypes.CartProps,
        showCart: PropTypes.bool.isRequired,
        readyForaddToCart: PropTypes.bool.isRequired,
        serverAliases: PropTypes.object,
        myself: MapPropTypes.UserProps,
        removeItemFromCart: PropTypes.func.isRequired,
        SaveCartItem: PropTypes.func.isRequired,
        updateStartDate: PropTypes.func.isRequired,
        updateMonthCount: PropTypes.func.isRequired,
        updateSeats: PropTypes.func.isRequired,
        updateServer: PropTypes.func.isRequired,
        updateWeekCount: PropTypes.func.isRequired,
        updateEndDate: PropTypes.func.isRequired,        
        editCart: PropTypes.bool.isRequired,
    };
   
    static mapState = (state) =>
        mapSelectors(state, {
            offer: selectors.offer.getSelectedOffer,
            isPricingContinuous: selectors.offer.getIsPricingContinuous,
            hasOnlyWeeklyPricing: selectors.offer.getHasOnlyWeeklyPricing,
            serversBySite: selectors.offer.getServersGroupedBySite,
            cart: selectors.cart.getCartContents,
            showCart: selectors.cart.showCart,           
            readyForaddToCart: selectors.cart.readyForaddToCart, 
            serverAliases: selectors.user.getServerAliases,
            myself: selectors.user.getMyself,
        });

    static mapDispatch = (dispatch) => ({
        updateStartDate: (index, startDate) =>
            dispatch(CartActions.updateItemStartDate(index, startDate)),
        updateDateRange: (index, startDate, endDate) =>
            dispatch(CartActions.updateItemDateRange(index, startDate, endDate)),
        updateEndDate: (index, endDate) =>
            dispatch(CartActions.updateItemEndDate(index, endDate)),
        updateMonthCount: (index, monthCount) =>
            dispatch(CartActions.updateItemMonthCount(index, monthCount)),
        updateWeekCount: (index, weekCount) =>
            dispatch(CartActions.updateItemWeekCount(index, weekCount)),
        updateSeats: (index, seats) =>
            dispatch(CartActions.updateItemSeats(index, seats)),
        updateSiteIndex: (index, siteIndex) =>
            dispatch(CartActions.updateItemSiteIndex(index, siteIndex)),
        updateServer: (index, siteIndex, serverIndex) =>
            dispatch(
                CartActions.updateItemServer(index, siteIndex, serverIndex)
            ),
        removeItemFromCart: (index, cartId) =>
            dispatch(CartActions.removeItemFromCart(index, cartId)),        
    });

    _renderItems() {
        if (this.props.cart.length === 0) {
            return (
                <tr>
                    <td colSpan="8" className="text-center">
                        <em className="text-gray-light">
                            {strings.selectAProduct}.
                        </em>
                    </td>
                </tr>
            );
        }
    
        return this.props.cart
            .map((item, originalIndex) => ({ ...item, originalIndex }))
            .filter((item) => item.addedToCart == this.props.editCart && !item.saveForLater)
            .map((item) => {                
                return(
                <CartItem
                    updateDateRange={(startDate, endDate) =>
                        this.props.updateDateRange(item.originalIndex, startDate, endDate)
                    }
                    updateStartDate={(startDate) => {
                            this.props.updateStartDate(item.originalIndex, startDate);                            
                        }
                    }
                    updateEndDate={(endDate) => {
                            this.props.updateEndDate(item.originalIndex, endDate);
                        }
                    }
                    updateMonthCount={(monthCount) => {
                            this.props.updateMonthCount(item.originalIndex, monthCount)
                        }
                    }
                    updateWeekCount={(weekCount) => {
                            this.props.updateWeekCount(item.originalIndex, weekCount);
                        }
                    }
                    updateSeats={(seats) => {
                            this.props.updateSeats(item.originalIndex, seats);
                        }
                    }
                    updateServer={(siteIndex, serverIndex) => {
                            this.props.updateServer(
                                item.originalIndex,
                                siteIndex,
                                serverIndex
                            );
                        }
                    }
                    removeItemFromCart={() =>
                        this.props.removeItemFromCart(item.originalIndex, item.cartId)
                    }
                    addItemToCart={() =>
                        this.props.SaveCartItem(item.originalIndex)
                    }
                    offer={this.props.offer}
                    serversBySite={this.props.serversBySite}
                    item={item}
                    readyForaddToCart={this.props.readyForaddToCart}
                    editCart= {this.props.editCart}
                    key={item.originalIndex} // Use original index as the key
                    serverAliases={this.props.serverAliases}
                    isPricingContinuous={this.props.isPricingContinuous}
                    hasOnlyWeeklyPricing={this.props.hasOnlyWeeklyPricing}
                    myself={this.props.myself}
                />
                );
            });
    }

    render() {
        if (!this.props.showCart && !this.props.editCart) {
            return <div />;
        }

        const firstThClasses = 'text-xs text-uppercase';
        const thClasses = 'text-center ' + firstThClasses;

        return (
            <table className="table m-b-0 cart">
                <thead>
                    <tr>
                        <th className={firstThClasses}>{strings.product}</th>
                        <th className={firstThClasses} width="350">
                            {strings.server}
                        </th>
                        <th className={thClasses} width="90">
                            {strings.seats}
                        </th>
                        <th className={thClasses} width="220">
                            {strings.duration}
                        </th>
                        <th className={thClasses}>{strings.creditsSeat}</th>
                        <th className={thClasses}>{strings.subtotal}</th>
                        <th className='actionLeftBorder'/>
                    </tr>
                </thead>
                <tbody>{this._renderItems()}</tbody>
            </table>
        );
    }
}

export default attach(Cart);



// WEBPACK FOOTER //
// ./app/components/Cart/index.jsx